import React from "react";
import "./../../UaeAttestation/UaeService/UaeService.css";
const AustraliaBloreCertHead = (props) => {
  return (
    <div className="uaeServiceHeadContainer">
      <h2>{props.head}</h2>
    </div>
  );
};

export default AustraliaBloreCertHead;
